<!--<app-form-header class="backoffice-page-header" btnAtras="procesadora/apikeys"></app-form-header>-->

<app-custom-header
  class="backoffice-page-header"
  [titulo]="'Api Key'"
  btnAtras="procesadora/apikeys">
</app-custom-header>

<mat-card>
  <div class="form-box">
    <form [formGroup]=" construirFormGroup()">

      <div class="container" fxLayout fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="10px"
           fxLayoutGap.xs="0">

        <mat-form-field appearance="outline">
          <mat-label>Comercio</mat-label>
          <input matInput formControlName="nombreFantasia" type="text" placeholder="Ingrese el nombre del comercio">
        </mat-form-field>


        <mat-form-field appearance="outline">
          <mat-label>Ruc</mat-label>
          <input matInput formControlName="ruc" type="text" placeholder="Ingrese el Ruc">
        </mat-form-field>

      </div>

      <div class="container" fxLayout fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="10px"
           fxLayoutGap.xs="0">

        <mat-form-field appearance="outline">
          <mat-label>Web</mat-label>
          <input matInput formControlName="web" type="text" placeholder="Ingrese la url de la web">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" type="text" placeholder="Ingrese el Correo">
        </mat-form-field>

      </div>

      <div class="container" fxLayout fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="10px"
           fxLayoutGap.xs="0">
        <mat-form-field appearance="outline">
          <mat-label>Api Key Producción</mat-label>
          <input matInput formControlName="apiKeyProduction" type="text" placeholder="Ingrese el key para producción">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Api key Test</mat-label>
          <input matInput formControlName="apiKeyTest" type="text" placeholder="Ingrese el key para Test">
        </mat-form-field>

      </div>

      <div class="container" fxLayout fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="10px"
           fxLayoutGap.xs="0">
        <mat-form-field appearance="outline">
          <mat-label>Codigo</mat-label>
          <input matInput formControlName="codigo" type="text" placeholder="Ingrese el Codigo">
        </mat-form-field>
      </div>

  <!--    <div class="button-box" *ngIf="abm">
        <app-form-actions (primaryEmiter)="guardar()" (acentEmiter)="cancelar()"
                          (warnEmiter)="eliminar(formularioAbs.value)" [hideBtnWarn]="!editar" [submitted]="submitted">
        </app-form-actions>
      </div>-->
    </form>


  </div>
</mat-card>
